import React from "react";
import { useTranslation } from "react-i18next";
import CheckIcon from "../../../../../assets/icons/blue-check.svg";
import "./AcceptManagerModal.less";

type AcceptManagerModalProps = {
  onClose: () => void;
  onAccept: () => void;
};

const AcceptManagerModal: React.FC<AcceptManagerModalProps> = ({ onClose, onAccept }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="manager-modal-overlay" onClick={handleOverlayClick}>
      <div className="manager-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="manager-modal-container">
          <img src={CheckIcon} className="manager-modal-icon" alt="Check" />
          <div className="manager-modal-title">{t("confirm-accept-manager-title")}</div>
          <div className="manager-modal-desc">{t("confirm-accept-manager-desc")}</div>
          <button className="manager-modal-accept-button" onClick={onAccept}>
            {t("i-accept")}
          </button>
          <button className="manager-modal-cancel-button" onClick={onClose}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcceptManagerModal;
